(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('appendToBody', appendToBodyDirective);

    function appendToBodyDirective($document, $compile) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var appendedElement = element;

                if (appendedElement) {
                    appendedElement.remove();
                }

                // Compile the element
                appendedElement.removeAttr('append-to-body');
                var compiledElement = $compile(appendedElement)(scope);

                // Append the element to the body
                $document[0].body.appendChild(compiledElement[0]);

                // Clean up on scope destroy
                scope.$on('$destroy', function() {
                    if (appendedElement) {
                        appendedElement.remove();
                    }
                });
            }
        }
    }
})();
